module.exports = __webpack_public_path__ + "img/2.f8a8a81.png";